import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '@mui/material';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Modal, Upload } from 'antd';
import { connect, useDispatch } from 'react-redux';
import Select from 'react-select';
import { AiOutlinePlus } from 'react-icons/ai';
import {
  email, IndMobileNumber, linkValidation, OTPMaxLength, renderField, required, requiredSelect
} from '../common/helpers/form-validations';
import UploadImage from '../common/uploadImage';
import { notifySet } from '../Services/Actions/CommonActions';
import '../assets/css/react-select.css';
import profileStyles from './UserDetails/MyProfile.module.css';
import { STATUS_MSG, renderSelect } from '../Services/config/globals';
import { renderSelectForPlan } from './UserMaster/StartUpForm';
import categoriesDropDownList from './Categories/categoriesDropDownList';

export const hereAboutOptions = [
  { id: 1, label: 'LinkedIn', value: 'LinkedIn' },
  { id: 2, label: 'Twitter', value: 'Twitter' },
  { id: 3, label: 'Events', value: 'Events' },
  { id: 4, label: 'Meeting', value: 'Meeting' },
  { id: 5, label: 'Others', value: 'Others' },
];
export const statusOptions = [
  { id: 1, value: 'Pending', label: 'Pending' },
  { id: 2, value: 'Approve', label: 'Approve' },
  { id: 3, value: 'Rejected', label: 'Rejected' },
];

function ServiceProviderForm(props) {
  const {
    handleSubmit,
    onButtonClick,
    buttonSaveText,
    handleFileChange,
    handleChangeLogo,
    file,
    logoImage,
    invalid,
    submitSucceeded,
    pristine,
    option,
    setOption,
    productGuideUploadOptions,
    saveProductGuide,
    productGuides,
    open,
    setOpen,
    setLinkURL,
    setProductGuides,
    cancelProductGuide,
  } = props;

  const dispatch = useDispatch();

  const onSubmit = (formData) => {
    if (logoImage.length < 1) {
      dispatch(notifySet({ type: 'error', message: STATUS_MSG.uploadLogo }));
    } else {
      onButtonClick(formData);
    }
  };

  const uploadButton = (
    <div className="btn btn-red" style={{ marginTop: 8 }}>
      Upload
    </div>
  );

  const deleteBox = (guide) => {
    const newProductGuides = productGuides.filter((g) => g !== guide);
    setProductGuides(newProductGuides);
  };

  return (
    <div>
      <form
        form="ServiceProviderForm"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="form-group">
              <label htmlFor="servicecategory">
                Partner Category <span className="validation-icon">*</span>
              </label>
              <Field
                type="dropdown"
                name="serviceCategory"
                placeholder="-- select one --"
                id="servicecategory"
                className="form-control"
                component={renderSelect}
                validate={[requiredSelect]}
                options={categoriesDropDownList()}
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="form-group">
              <label htmlFor="serviceprovidername">
                Service Partner Name <span className="validation-icon">*</span>
              </label>
              <Field
                component={renderField}
                type="text"
                name="serviceprovidername"
                validate={[required]}
                id="serviceprovidername"
                className="form-control"
                placeholder="Enter name"
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="form-group upload-input-img">
              <label htmlFor="web">
                Upload Logo <span className="validation-icon">*</span>
              </label>
              <br />
              <UploadImage
                handleChangeLogo={handleChangeLogo}
                logoImage={logoImage}
              />
              {/* {logoImage.length < 1 ? (
                <span className="text-danger small">
                  *Mandatory: Please upload logo.*
                </span>
              ) : null} */}
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="form-group">
              <label htmlFor="web">
                Website URL <span className="validation-icon">*</span>
              </label>
              <Field
                component={renderField}
                type="text"
                name="websiteURL"
                validate={[required, linkValidation]}
                id="web"
                className="form-control"
                placeholder="https://"
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="form-group">
              <label htmlFor="brief">
                Introduction <span className="validation-icon">*</span>
              </label>
              <Field
                component={renderField}
                type="textarea"
                name="briefIntroduction"
                validate={[required]}
                id="brief"
                className="form-control"
                placeholder="Enter here"
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="form-group">
              <label htmlFor="what">
                Deal details & offerings <span className="validation-icon">*</span>
              </label>
              <Field
                component={renderField}
                type="textarea"
                name="dealDetail"
                validate={[required]}
                id="what"
                className="form-control"
                placeholder="Enter here"
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="form-group upload-input-img upload-input-img-list">
              <label htmlFor="pg">Product Guide (maximum 5 files)</label> &nbsp;
              {productGuides.length >= 5 ? null : (
                <span
                  className="addcircle"
                  onClick={() => setOpen(true)}
                >
                  <AiOutlinePlus />
                </span>
              )}
              <div className="tag-btn-title-list-tag">
                <div className={`${profileStyles['tag-btn-menu-ul-con']} ${profileStyles.smaller}`}>
                  <ul>
                    {productGuides?.map((guide, index) => (
                      <li key={index}>
                        <div className={`${profileStyles['box-file']}`}>
                          {guide.title}
                          <button
                            onClick={() => deleteBox(guide)}
                            type="button"
                          >
                            <CloseIcon sx={{ fontSize: 10 }} />
                          </button>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <Modal
                open={open}
                onCancel={() => cancelProductGuide()}
                onOk={() => saveProductGuide()}
                okText="Save"
              >
                <h6>Add Product Guide</h6>
                <Select
                  options={productGuideUploadOptions}
                  onChange={setOption}
                  value={option}
                />
                <br />
                {option?.value === 'file' ? (
                  <Upload
                    maxCount={1}
                    fileList={file}
                    onChange={handleFileChange}
                    accept="image/*, application/pdf"
                    // eslint-disable-next-line
                    beforeUpload={() => {
                      return false;
                    }}
                  >
                    {file.length >= 1 ? null : uploadButton}
                  </Upload>
                ) : (
                  <>
                    <label htmlFor="link">Link</label>
                    <Field
                      component={renderField}
                      type="text"
                      onChange={(e) => setLinkURL(e.target.value)}
                      name="linkURL"
                      validate={[linkValidation]}
                      className="form-control"
                      placeholder="https://"
                    />
                  </>
                )}
              </Modal>
              {/* {file.length < 1 ? (
                <span className="text-danger small">
                  *Mandatory: Please upload atleast one file.*
                </span>
              ) : null} */}
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="form-group">
              <label htmlFor="dealp">
                Deal Redemption Process <span className="validation-icon">*</span>
              </label>
              <Field
                component={renderField}
                type="textarea"
                name="dealRedemptionProcess"
                validate={[required]}
                id="dealp"
                className="form-control"
                placeholder="Share process for startups to redeem this partner deal"
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="form-group">
              <label htmlFor="deal">Redemption Link</label>
              <Field
                component={renderField}
                type="text"
                name="dealRedemptionLink"
                id="deal"
                className="form-control"
                placeholder="Enter here"
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="form-group">
              <label htmlFor="est">
                Estimated offer value (In USD) <span className="validation-icon">*</span>
              </label>
              <Field
                component={renderField}
                name="estimatedValue"
                validate={[required, OTPMaxLength]}
                id="est"
                className="form-control"
                placeholder="$ 00"
                type="number"
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="form-group">
              <label htmlFor="elg">
                Eligibility Criteria <span className="validation-icon">*</span>
              </label>
              <Field
                component={renderField}
                type="textarea"
                name="eligibilityCriteria"
                validate={[required]}
                id="elg"
                className="form-control"
                placeholder="Enter here"
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="form-group">
              <label htmlFor="pocname">
                Partner PoC Name <span className="validation-icon">*</span>
              </label>
              <Field
                component={renderField}
                type="text"
                name="PoCName"
                validate={[required]}
                id="pocname"
                className="form-control"
                placeholder="Enter here"
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="form-group">
              <label htmlFor="pocemail">
                Partner PoC Email ID <span className="validation-icon">*</span>
              </label>
              <Field
                component={renderField}
                type="text"
                name="PoCEmailID"
                validate={[required, email]}
                id="pocemail"
                className="form-control"
                placeholder="example@gmail.com"
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="form-group">
              <label htmlFor="poccontact">Partner PoC Contact</label>
              <Field
                component={renderField}
                type="number"
                name="phoneNumber"
                validate={[IndMobileNumber]}
                id="brief"
                className="form-control"
                placeholder="01234 56789"
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="form-group">
              <label htmlFor="remark">Remarks</label>
              <Field
                component={renderField}
                type="textarea"
                name="remark"
                id="remark"
                className="form-control"
                placeholder="Enter here"
              />
            </div>
          </div>
          {props.action === 'edit' && (
            <div className="col-sm-12 col-md-12 col-lg-3">
              <div className="form-group">
                <label htmlFor="status">
                  Status <span className="validation-icon">*</span>
                </label>
                <Field
                  component={renderSelectForPlan}
                  type="dropdown"
                  options={statusOptions}
                  defaultValue={statusOptions[0]}
                  name="status"
                  id="status"
                  className="form-control"
                  placeholder="-- select one --"
                />
              </div>
            </div>
          )}
          {props.action === 'edit' && <div className="col-sm-12 col-md-12 col-lg-9" />}
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="form-group">
              <label htmlFor="referrerName">
                Referrer Name <span className="validation-icon">*</span>
              </label>
              <Field
                component={renderField}
                validate={[required]}
                type="text"
                maxLength={100}
                name="referrerName"
                id="referrerName"
                className="form-control"
                placeholder="Mention name of CIIE.CO team if applicable"
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="form-group">
              <label htmlFor="hearAboutUs">
                How did you hear about us? <span className="validation-icon">*</span>
              </label>
              <Field
                component={renderSelectForPlan}
                options={hereAboutOptions}
                validate={[required]}
                type="dropdown"
                name="hearAboutUs"
                id="hearAboutUs"
                className="form-control"
                placeholder="-- select one --"
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6" />
          {props.formValues?.hearAboutUs?.value === 'Others' && (
            <div className="col-sm-12 col-md-12 col-lg-6">
              <div className="form-group">
                <label htmlFor="hearOther">
                  Others <span className="validation-icon">*</span>
                </label>
                <Field
                  component={renderField}
                  validate={[required]}
                  type="text"
                  name="hearOther"
                  id="hearOther"
                  maxLength={50}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>
          )}
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="form-group mt-1">
              <Button
                type="submit"
                className="btn btn-red"
                disabled={invalid || submitSucceeded || pristine}
              >
                {buttonSaveText}
              </Button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

const withForm = reduxForm({
  enableReinitialize: true,
  form: 'ServiceProviderForm',
})(ServiceProviderForm);

export default connect((state) => ({
  formValues: formValueSelector('ServiceProviderForm')(state, 'hearAboutUs', 'hearOther'),
}))(withForm);
